import { useState, type ComponentPropsWithoutRef } from "react";

type PasswordFieldProps = Omit<ComponentPropsWithoutRef<"input">, "type"> & {
  inputClassName?: string;
};

export const PasswordField = ({
  inputClassName = "",
  className = "",
  ...props
}: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <span className={`miboard-password-field ${className}`.trim()}>
      <input
        {...props}
        className={`${inputClassName} miboard-password-field__input`.trim()}
        type={visible ? "text" : "password"}
      />
      <button
        className="miboard-password-field__toggle"
        type="button"
        aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
        aria-pressed={visible}
        onClick={() => setVisible((current) => !current)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none">
          <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
          <circle cx="12" cy="12" r="2.5" />
          {visible && <path d="m4 4 16 16" />}
        </svg>
      </button>
    </span>
  );
};
